import { useState, useEffect, useRef } from 'react';
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export function useWindowDimensions() {
  const windowDimensions = useRef(getWindowDimensions());
  const [retDimentions, setRetDimentions] = useState(getWindowDimensions());

  const handleResize = () => {
    var dimentions = getWindowDimensions();
    if(dimentions.height !== windowDimensions.current.height || dimentions.width !== windowDimensions.current.width)
    {
        windowDimensions.current = dimentions;
        setRetDimentions(dimentions);
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return retDimentions;
}

export function useMainDisplayHeight() {
  const windowDimensions = useRef(getWindowDimensions());

  return windowDimensions.current.height - 165;
}